
export function Toggle({
  checked,
  onChange,
  label,
}: {
  checked: boolean;
  onChange: (v: boolean) => void;
  label?: string;
}) {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      onClick={() => onChange(!checked)}
      className={`relative inline-flex h-5 w-9 items-center rounded-full transition ${
        checked ? "bg-zinc-900 dark:bg-accent" : "bg-zinc-300 dark:bg-surface-2"
      }`}
    >
      <span
        className={`inline-block h-3.5 w-3.5 transform rounded-full shadow transition ${
          checked
            ? "translate-x-5 bg-white dark:bg-surface"
            : "translate-x-1 bg-white dark:bg-zinc-100"
        }`}
      />
      {label ? <span className="sr-only">{label}</span> : null}
    </button>
  );
}
